import React from 'react';
import useRequest from "@hooks/useRequest"
import { IEmpresa } from "@model/Empresa";

export function useEmpresaService () {
    const _request = useRequest();

    const listarAtivas = React.useCallback(() => {
        return _request.get<IEmpresa[]>("Empresa/ListarAtivas");
    }, [_request]);

    return React.useMemo(() => ({
        listarAtivas
    }), [listarAtivas]);
}